import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { HandlerService } from '../handler.service';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { LocationService } from '../location.service';
// import { PushService } from '../push.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomSheet } from '../bottom.sheet';
import { Storage } from '@ionic/storage';
import { ApiService } from '../api.service';
import * as sha512 from 'js-sha512';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {

  phone; check: boolean = false;loader:boolean = false;
  otp; mobileVerify: any = {}; userId;id;numb;
 vendoruser:boolean=true;
 vendoruserId;vendorMobile;url;mobileVerify1;
  constructor(private auth: AuthService,
    private service:ApiService,
              public handler: HandlerService,
              public router: Router) { }

  ngOnInit() {
  this.url=window.location.href;
  // this.phone = sessionStorage.getItem('phone')
  this.vendoruserId = localStorage.getItem('vendoruserId')
  this.vendorMobile = localStorage.getItem('vendorMobile')
  this.id = localStorage.getItem('orderId')
  }

  sendOtp() {
    this.loader = true;
    // localStorage.setItem('mobile',this.phone);
    this.mobileVerify1 = { }
    if(this.url.includes('vendor')){
      this.userId = localStorage.getItem('vendoruserId');
      this.phone=localStorage.getItem('vendorMobile');
    }else{
      this.userId = localStorage.getItem('currentUserId');
      this.phone=localStorage.getItem('mobile');
    }
    this.service.sendMobileOtp(this.userId,this.phone).subscribe(res => {
     
      // this.service.sendMobileOtp( window['mock'].userId, window['mock'].contactNbrMob).subscribe(res => {
      this.check = true;
      this.loader = false;
      this.handler.res('OTP Sent Successfully');
      if(this.url.includes('vendor')){
        this.router.navigate(['/vendor-login']);
      }else{
        this.router.navigate(['/login']);
      }
  
    },err=>{
      this.handler.err(err);
      this.check = true;
      this.loader = false;
    })
    
    
  }


  validateNumber(event) {
    event.target.value = event.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').slice(0, 13);
    this.phone = event.target.value
  }


  validate(event) {
    event.target.value = event.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').slice(0, 6);
    this.otp = event.target.value;
    this.validMobileOtp()
  }

  onpaste(event) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text');
    event.target.value = pastedText.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').slice(0, 6);
    this.otp = event.target.value;
    this.validMobileOtp()
  }

  validMobileOtp() {
    this.vendoruser=false;
    if (this.otp.length == 6) {
      if (this.otp != undefined || null) {
        var m = sha512.sha512(this.otp.toString());
      }
      this.mobileVerify = { mobileOTP: m }
      if(this.url.includes('vendor')){
        Object.assign( this.mobileVerify, { "userId": localStorage.getItem('vendoruserId') })
        // Object.assign( this.mobileVerify, { "contactNbrMob": localStorage.getItem('vendorMobile') })
      }else{
        Object.assign( this.mobileVerify, { "userId": localStorage.getItem('currentUserId') })
        // Object.assign( this.mobileVerify, { "contactNbrMob": localStorage.getItem('mobile') })
      }
      this.loader = true;
      this.service.validateOtp(this.mobileVerify).subscribe(res => {
        this.handler.res('Validated Successfully')
        localStorage.setItem('mobile',this.phone)
        sessionStorage.removeItem('phone')
        this.loader = false;
        if(this.url.includes('vendor')){
          this.router.navigate(['/vendoraddress']);
        }else{
           this.router.navigate(['invoice/' +this.id]);
        }
        // this.router.navigate(['invoice/' +this.id]);

        
      },
        err => {
          this.handler.err(err);
          this.loader = false;
        })
    }
  }


  
  
 

  
ionViewWillLeave(){
  this.phone = ""
}
}
